import React from 'react';
import NumberFormat from 'react-number-format';

interface rutValues {
	value: string;
	formatValue: string;
}

export const unformat = (rut: string) => {
	return rut.replace(/[^0-9kK]/g, '');
};

const formatRut = (rut: string): rutValues => {
	const current = rut.replace(/^0+/, '');

	if (current !== '' && current.length > 1) {
		const unformatRut = unformat(current);
		const cleanRut = unformatRut.substring(0, unformatRut.length - 1);
		let rutNumberFormat = '';

		let i = 0;
		let j = 1;

		for (i = cleanRut.length - 1; i >= 0; i--) {
			rutNumberFormat = cleanRut.charAt(i) + rutNumberFormat;
			if (j % 3 === 0 && j <= cleanRut.length - 1) {
				rutNumberFormat = '.' + rutNumberFormat;
			}
			j++;
		}

		let dv = unformatRut.substring(unformatRut.length - 1);
		rutNumberFormat = rutNumberFormat + '-' + dv;
		return { value: unformatRut, formatValue: rutNumberFormat };
	}
	return { value: current, formatValue: current };
};

export const CustomInputRutMask = (props: any) => {
	const { onChange, inputRef, ...other } = props;

	return (
		<input
			ref={inputRef}
			onChange={(e) => {
				let inputValue = {
					formatValue: '',
					value: '',
				};
				inputValue = formatRut(e.target.value);
				//e.target.value = inputValue.formatValue;
				onChange({ target: { value: inputValue.formatValue } });
			}}
			{...other}
		/>
	);
};

export const NumberFormatCustom = (props: any) => {
	const { format, inputRef, onChange, ...other } = props;

	const customProps =
		format === 'money'
			? {
					thousandSeparator: '.',
					decimalSeparator: 'n',
			  }
			: {
					format,
			  };

	return (
		<NumberFormat
			getInputRef={inputRef}
			onValueChange={(values) => {
				onChange({
					target: {
						value: values.value,
					},
				});
			}}
			allowNegative={false}
			//isNumericString={true}
			{...customProps}
			{...other}
		/>
	);
};
